<script setup lang="ts">
import type { InteractionEditorProps } from '../../../../model/assessments/interaction-editors.hook'

import { AppText } from '@shared/ui/typography'

import { useInteractionWhiteboard } from '../../../../model/assessments/interaction-editors.hook'
import ImageUploader from '../ImageUploader.vue'

defineOptions({
  name: 'InteractionWhiteboard',
})

const props = defineProps<InteractionEditorProps>()

const {
  refBackgroundUrl,
  refBackgroundAlt,
  setBackgroundUrl,
} = useInteractionWhiteboard({
  screenId: () => props.screenId,
  activityId: () => props.activityId,
  interaction: () => props.interaction,
})
</script>

<template>
  <div class="interaction-whiteboard">
    <AppText
      name="body2"
      color="slate-500"
    >
      The kid draws their working. An optional background image sits under the drawing — a number
      line or a grid to work on.
    </AppText>

    <!-- The same uploader the image content block uses: `backgroundAsset` is shaped like
         `AssetRef`, so an uploaded object path or an external URL both live in its `url`. -->
    <ImageUploader
      label="Background image"
      :value="refBackgroundUrl"
      :alt="refBackgroundAlt"
      @update:value="setBackgroundUrl"
    />
  </div>
</template>

<style scoped lang="scss" src="./InteractionWhiteboard.scss" />
